<template>
  <span v-if="isNew" class="sale-badge sale-red">
    NEU
  </span>
</template>

<script>
export default {
  name: "NewBadge",
  props: {
    releasedAt: {
      type: String,
      default: null
    }
  },
  computed: {
    isNew() {
      if (!this.releasedAt) return false;

      const releaseDate = new Date(this.releasedAt);
      const now = new Date();

      // 1 Monat zurück
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(now.getMonth() - 1);

      return releaseDate >= oneMonthAgo && releaseDate <= now;
    }
  }
};
</script>

<style scoped></style>
